// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExternalReferenceModel {
    static getAttributeTypeMap() {
        return ExternalReferenceModel.attributeTypeMap;
    }
}
ExternalReferenceModel.discriminator = undefined;
ExternalReferenceModel.additionalProperties = false;
ExternalReferenceModel.attributeTypeMap = [
    {
        "name": "externalReferenceTypeId",
        "baseName": "externalReferenceTypeId",
        "type": "number"
    },
    {
        "name": "externalValue",
        "baseName": "externalValue",
        "type": "string"
    },
];
//# sourceMappingURL=externalReferenceModel.js.map